/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MissionInfoJson } from './MissionInfoJson';
import {
    MissionInfoJsonFromJSON,
    MissionInfoJsonFromJSONTyped,
    MissionInfoJsonToJSON,
} from './MissionInfoJson';

/**
 * 
 * @export
 * @interface NotificationDtoJson
 */
export interface NotificationDtoJson {
    /**
     * 
     * @type {number}
     * @memberof NotificationDtoJson
     */
    alertId?: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationDtoJson
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDtoJson
     */
    missionId?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDtoJson
     */
    type: NotificationDtoJsonTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationDtoJson
     */
    level: NotificationDtoJsonLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationDtoJson
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDtoJson
     */
    message: string;
    /**
     * 
     * @type {Date}
     * @memberof NotificationDtoJson
     */
    timestamp: Date;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationDtoJson
     */
    read: boolean;
    /**
     * 
     * @type {string}
     * @memberof NotificationDtoJson
     */
    actionUrl?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof NotificationDtoJson
     */
    data?: { [key: string]: object; };
    /**
     * 
     * @type {MissionInfoJson}
     * @memberof NotificationDtoJson
     */
    missionInfo?: MissionInfoJson;
}


/**
 * @export
 */
export const NotificationDtoJsonTypeEnum = {
    ASSIGNMENT_EXPIRED: 'ASSIGNMENT_EXPIRED',
    ASSIGNMENT_REJECTED: 'ASSIGNMENT_REJECTED',
    ASSIGNMENT_ACCEPTED: 'ASSIGNMENT_ACCEPTED',
    MISSION_COMPLETED: 'MISSION_COMPLETED',
    MISSION_CANCELLED: 'MISSION_CANCELLED',
    DRIVER_UNAVAILABLE: 'DRIVER_UNAVAILABLE',
    DRIVER_AVAILABLE: 'DRIVER_AVAILABLE',
    HIGH_PRIORITY_MISSION: 'HIGH_PRIORITY_MISSION',
    MISSION_ASSIGNED_TO_DRIVER: 'MISSION_ASSIGNED_TO_DRIVER',
    MISSION_DELAYED: 'MISSION_DELAYED',
    SYSTEM: 'SYSTEM'
} as const;
export type NotificationDtoJsonTypeEnum = typeof NotificationDtoJsonTypeEnum[keyof typeof NotificationDtoJsonTypeEnum];

/**
 * @export
 */
export const NotificationDtoJsonLevelEnum = {
    INFO: 'INFO',
    WARNING: 'WARNING',
    ERROR: 'ERROR'
} as const;
export type NotificationDtoJsonLevelEnum = typeof NotificationDtoJsonLevelEnum[keyof typeof NotificationDtoJsonLevelEnum];


/**
 * Check if a given object implements the NotificationDtoJson interface.
 */
export function instanceOfNotificationDtoJson(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "level" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "read" in value;

    return isInstance;
}

export function NotificationDtoJsonFromJSON(json: any): NotificationDtoJson {
    return NotificationDtoJsonFromJSONTyped(json, false);
}

export function NotificationDtoJsonFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationDtoJson {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'alertId': !exists(json, 'alertId') ? undefined : json['alertId'],
        'userId': json['userId'],
        'missionId': !exists(json, 'missionId') ? undefined : json['missionId'],
        'type': json['type'],
        'level': json['level'],
        'title': json['title'],
        'message': json['message'],
        'timestamp': (new Date(json['timestamp'])),
        'read': json['read'],
        'actionUrl': !exists(json, 'actionUrl') ? undefined : json['actionUrl'],
        'data': !exists(json, 'data') ? undefined : json['data'],
        'missionInfo': !exists(json, 'missionInfo') ? undefined : MissionInfoJsonFromJSON(json['missionInfo']),
    };
}

export function NotificationDtoJsonToJSON(value?: NotificationDtoJson | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'alertId': value.alertId,
        'userId': value.userId,
        'missionId': value.missionId,
        'type': value.type,
        'level': value.level,
        'title': value.title,
        'message': value.message,
        'timestamp': (value.timestamp.toISOString()),
        'read': value.read,
        'actionUrl': value.actionUrl,
        'data': value.data,
        'missionInfo': MissionInfoJsonToJSON(value.missionInfo),
    };
}

